import { render, staticRenderFns } from "./ListDues.vue?vue&type=template&id=2663e3ce&scoped=true"
import script from "./ListDues.vue?vue&type=script&lang=js"
export * from "./ListDues.vue?vue&type=script&lang=js"
import style0 from "./ListDues.vue?vue&type=style&index=0&id=2663e3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2663e3ce",
  null
  
)

export default component.exports